/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import { defineMessages } from 'react-intl'

export const SET_USER = 'SET_USER'

export const messages = defineMessages({
  TITLE: {
    id: 'user.TITLE',
    defaultMessage: 'user.TITLE'
  },
  PASSWORD_LABEL: {
    id: 'user.PASSWORD_LABEL',
    defaultMessage: 'user.PASSWORD_LABEL'
  },
  CONFIRM_LABEL: {
    id: 'user.CONFIRM_LABEL',
    defaultMessage: 'user.CONFIRM_LABEL'
  },
  SUBMIT_LABEL: {
    id: 'user.SUBMIT_LABEL',
    defaultMessage: 'user.SUBMIT_LABEL'
  },
  PASSWORD_MISMATCH: {
    id: 'user.PASSWORD_MISMATCH',
    defaultMessage: 'user.PASSWORD_MISMATCH'
  },
  CONFIRMATION_MESSAGE: {
    id: 'user.CONFIRMATION_MESSAGE',
    defaultMessage: 'user.CONFIRMATION_MESSAGE'
  },
  BACK_LABEL: {
    id: 'user.BACK_LABEL',
    defaultMessage: 'user.BACK_LABEL'
  },
  USER_LABEL: {
    id: 'user.USER_LABEL',
    defaultMessage: 'user.USER_LABEL'
  }
})



// WEBPACK FOOTER //
// ./src/constants/User.js